import RoomSocket from "./roomSocket";
import roomS2C from "./roomS2C";



export default class RoomSocketMgr {

    static isConnected = false;

    static connectServer(uid,fastkey) {
        if (RoomSocketMgr.isConnected) {  
            return;
        }
        RoomSocket.instance.addHandler(new roomS2C());
        RoomSocket.instance.connect(uid,fastkey);
    }

    static closeWebSocket() {
        RoomSocketMgr.isConnected = false;
        RoomSocket.instance.forceCloseSocket();
    }

}